// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1x0Wj","question":"Question_question__1ec3W","description":"Question_description__2vNvY"};